import { brokerApi } from './brokerClient'

export interface AppItem {
  slug: string
  display_name: string
  environment: 'DEV' | 'QA' | 'HML' | 'PRD'
  protocol: 'http' | 'ssh' | 'tcp'
  hostname: string
  identity_mode: 'header' | 'oidc' | 'mtls'
  routing_mode: 'direct' | 'connector'
  access_url: string | null
  cli_command: string | null
}

export const appsApi = {
  /** Lista apps acessiveis pelo usuario logado (broker /me/apps). */
  listMine: async (): Promise<AppItem[]> => {
    const r = await brokerApi.get<{ apps: AppItem[] }>('/_broker/api/me/apps')
    return r.data.apps
  },
}
